export default class ModalOpener extends HTMLElement {
    constructor() {
        super();
    
        const button = this.querySelector('button');
    
        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            const buttonType = this.getAttribute('data-button');
            
            // If button has a type of 'toggle' then add is-active class
            if (modal && buttonType === 'toggle' && !button.classList.contains('is-active')) {
                button.classList.add('is-active');
                modal.show(button);
            } else if (modal && buttonType === 'toggle' && button.classList.contains('is-active')) {
                modal.hide();
            } else if (modal) {
                button.classList.add('is-active');
                modal.show(button);
            } else {
                modal.hide();
            }
        });
    }
}

customElements.define('modal-opener', ModalOpener);
